// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__35wdE","isSmall":"Footer_isSmall__hA7cx","isMobile":"Footer_isMobile__D8haU","links":"Footer_links__3Cx6x"};